__turbopack_context__.v({
  "adminMessage": "floating-messages-module__YM1YQq__adminMessage",
  "conversationSelect": "floating-messages-module__YM1YQq__conversationSelect",
  "empty": "floating-messages-module__YM1YQq__empty",
  "error": "floating-messages-module__YM1YQq__error",
  "float": "floating-messages-module__YM1YQq__float",
  "form": "floating-messages-module__YM1YQq__form",
  "loginPrompt": "floating-messages-module__YM1YQq__loginPrompt",
  "messages": "floating-messages-module__YM1YQq__messages",
  "ownMessage": "floating-messages-module__YM1YQq__ownMessage",
  "panel": "floating-messages-module__YM1YQq__panel",
  "panelHead": "floating-messages-module__YM1YQq__panelHead",
  "pulse": "floating-messages-module__YM1YQq__pulse",
  "toggle": "floating-messages-module__YM1YQq__toggle",
  "unread": "floating-messages-module__YM1YQq__unread",
  "widget": "floating-messages-module__YM1YQq__widget",
});
